import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const surveyConfig = {
  url: 'https://docs.google.com/forms/d/e/1FAIpQLSfqbreUOMP5WMwO81MUGFnW3TzwovukVaKGNb210bkiS57doA/viewform',
  prefill: {
    email: {
      entry_id: '239873797'
    },
    isUser: {
      entry_id: '1887410848',
      default: '%E6%98%AF'
    }
  }
};

const useStyles = makeStyles()(theme => ({
  button: {
    textTransform: 'none',
    borderRadius: 8,
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  text: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: 16,
    marginRight: 4,
    marginLeft: 8
  },
  icon: {
    width: 28,
    height: 28
  },
  iconArrow: {
    width: 18,
    height: 18
  }
}));

const getSurveyUrl = (config, data) => {
  if (!config || !config.url) return null;
  let url = config.url;
  Object.entries(config.prefill).forEach(([key, item]) => {
    if (data[key] || item.default) {
      const value = data[key] || item.default;
      if (!value) return;
      if (!url.includes('?')) {
        url += '?';
      }
      if (url.endsWith('?')) {
        url += `entry.${item.entry_id}=${value}`;
      } else {
        url += `&entry.${item.entry_id}=${value}`;
      }
    }
  });
  return url;
};

const SurveyButton = ({ data, config, onClick, ...rest }) => {
  const { classes } = useStyles();
  const url = getSurveyUrl(config, data);
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    window.open(url, '_blank');
  };

  if (!url) return <></>;

  return (
    <Button className={classes.button} onClick={handleClick} disableRipple {...rest}>
      <Box
        wrap="nowrap"
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <img src="img/icons/EditDocumentIcon.svg" className={classes.icon} />
        <Typography className={classes.text}>意見調査</Typography>
        <img src="img/icons/ArrowOutwardIcon.svg" className={classes.iconArrow} />
      </Box>
    </Button>
  );
};

export default SurveyButton;
